import { Button, FormControl, FormLabel, MenuItem, TextField } from "@material-ui/core";
import { Help, Loop } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { Formik } from "formik";
import React from "react";
import { object, string } from "yup";
import SelectDropOtions from "../../../components/SelectDropOtions";
import TextareaApp from "../../../components/TextareaApp";

export default function SwitchComponentActionsForm({
    type = "",
    response = () => ({ values: null, type }),
    dataOptions,
}) {
    if (type === "") return <Skeleton width={"100%"} height={50} />;
    if (type === "Call") {
        return (
            <div>
                <div className="text-center t-text-primary w-100">
                    <Help style={{ width: 60, height: 60, marginBottom: 16 }} />
                    <p>ต้องการเรียกคิวชำระเงิน ?</p>
                </div>
                <div className="d-flex justify-content-center align-items-center w-100">
                    <Button onClick={() => response({ status: false }, type)} className="btn t-btn-gray mx-3">
                        ไม่
                    </Button>
                    <Button onClick={() => response({ status: true }, type)} className="btn t-btn-primary mx-3">
                        ใช่
                    </Button>
                </div>
            </div>
        );
    } else if (type === "Selected") {
        return (
            <div>
                <div className="text-center t-text-primary w-100">
                    <Help style={{ width: 60, height: 60, marginBottom: 16 }} />
                    <p>ต้องการเลือกคิวชำระเงิน ?</p>
                </div>
                <div className="d-flex justify-content-center align-items-center w-100">
                    <Button onClick={() => response({ status: false }, type)} className="btn t-btn-gray mx-3">
                        ไม่
                    </Button>
                    <Button onClick={() => response({ status: true }, type)} className="btn t-btn-primary mx-3">
                        ใช่
                    </Button>
                </div>
            </div>
        );
    } else if (type === "Confirm") {
        return (
            <div>
                <div className="text-center t-text-primary w-100">
                    <Help style={{ width: 60, height: 60, marginBottom: 16 }} />
                    <p>ยืนยันการชำระเงิน ?</p>
                </div>
                <div className="d-flex justify-content-center align-items-center w-100">
                    <Button onClick={() => response({ status: false }, type)} className="btn t-btn-gray mx-3">
                        ไม่
                    </Button>
                    <Button onClick={() => response({ status: true }, type)} className="btn t-btn-primary mx-3">
                        ใช่
                    </Button>
                </div>
            </div>
        );
    } else if (type === "Hold") {
        return (
            <div>
                <div className="text-center t-text-primary w-100">
                    <Help style={{ width: 60, height: 60, marginBottom: 16 }} />
                    <p>ต้องการพักการชำระเงิน ?</p>
                </div>
                <div className="d-flex justify-content-center align-items-center w-100">
                    <Button onClick={() => response({ status: false }, type)} className="btn t-btn-gray mx-3">
                        ไม่
                    </Button>
                    <Button onClick={() => response({ status: true }, type)} className="btn t-btn-primary mx-3">
                        ใช่
                    </Button>
                </div>
            </div>
        );
    } else if (type === "Message") {
        return (
            <div>
                <div className="text-center t-text-primary w-100">
                    <Help style={{ width: 60, height: 60, marginBottom: 16 }} />
                    <p>ต้องการส่งข้อความแจ้งเตือน ?</p>
                </div>
                <Formik
                    initialValues={{ title: "", description: "" }}
                    validationSchema={object({
                        title: string().required("Required."),
                        description: string().required("Required."),
                    })}
                    onSubmit={values => {
                        response({ status: true, title: values?.title, message: values?.description }, type);
                    }}>
                    {({ values, errors, handleChange, handleSubmit }) => (
                        <>
                            <div className="mb-3">
                                <FormControl fullWidth className="t-form-group-custom">
                                    <FormLabel>หัวข้อการแจ้งเตือน</FormLabel>
                                    <TextField
                                        value={values?.title}
                                        name="title"
                                        onChange={handleChange}
                                        variant="outlined"
                                        error={Boolean(errors?.title)}
                                        helperText={errors?.title}
                                    />
                                </FormControl>
                            </div>
                            <div className="mb-3">
                                <FormLabel>ข้อความการแจ้งเตือน</FormLabel>
                                <TextareaApp
                                    props={{
                                        textAreaProps: {
                                            rows: 5,
                                            value: values?.description,
                                            id: "description",
                                            onChange: handleChange,
                                        },
                                    }}
                                    errorMessage={errors?.description}
                                />
                            </div>
                            <div className="d-flex justify-content-center align-items-center w-100">
                                <Button
                                    onClick={() => response({ status: false }, type)}
                                    className="btn t-btn-gray mx-3">
                                    ไม่
                                </Button>
                                <Button onClick={handleSubmit} className="btn t-btn-primary mx-3">
                                    ใช่
                                </Button>
                            </div>
                        </>
                    )}
                </Formik>
            </div>
        );
    } else if (type === "Transfer") {
        return (
            <div>
                <div className="text-center t-text-primary w-100">
                    <Loop style={{ width: 60, height: 60, marginBottom: 16 }} />
                    <p>ต้องการย้ายการชำระเงิน ?</p>
                </div>
                <Formik
                    initialValues={{ building: "", floor: "" }}
                    validationSchema={object({
                        building: string().required("Required."),
                        floor: string().required("Required."),
                    })}
                    onSubmit={values => {
                        response({ status: true, values }, type);
                    }}>
                    {({ values, errors, setFieldValue, handleSubmit }) => (
                        <div className="row">
                            <div className="col-12 mb-2">
                                <FormLabel className="text-center t-text-primary w-100">
                                    โปรดระบุชั้นที่ต้องการย้าย
                                </FormLabel>
                            </div>
                            <div className="col-12 col-lg-6 mb-5">
                                <div>
                                    <SelectDropOtions
                                        containerClass="border"
                                        options={dataOptions?.building}
                                        value={values?.building}
                                        onChange={value => setFieldValue("building", value)}
                                        error={Boolean(errors?.building)}
                                        helperText={errors?.building}
                                        placeholder="Building"
                                        renderOption={(row, idx) => (
                                            <MenuItem key={"b_" + idx} value={row.buildingId}>
                                                {row?.name}
                                            </MenuItem>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 mb-5">
                                <div>
                                    <SelectDropOtions
                                        containerClass="border"
                                        options={dataOptions?.floor.filter(
                                            item => item?.buildingId === values?.building,
                                        )}
                                        value={values?.floor}
                                        onChange={value => setFieldValue("floor", value)}
                                        error={Boolean(errors?.floor)}
                                        helperText={errors?.floor}
                                        placeholder="Floor"
                                        renderOption={(row, idx) => (
                                            <MenuItem key={"f_" + row.floorId} value={row}>
                                                {row.name} {row.locationName}
                                            </MenuItem>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="col-12 pt-4">
                                <div className="d-flex justify-content-center align-items-center w-100">
                                    <Button
                                        onClick={() => response({ status: false }, type)}
                                        className="btn t-btn-gray mx-3">
                                        ไม่
                                    </Button>
                                    <Button onClick={handleSubmit} className="btn t-btn-primary mx-3">
                                        ใช่
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Formik>
            </div>
        );
    } else if (type === "Cancel") {
        return (
            <div>
                <div className="text-center t-text-primary w-100">
                    <Help style={{ width: 60, height: 60, marginBottom: 16 }} />
                    <p>ต้องการยกเลิกชำระเงิน ?</p>
                </div>
                <Formik
                    initialValues={{ text: "" }}
                    validationSchema={object({ text: string().required("Required.") })}
                    onSubmit={values => {
                        response({ status: true, values }, type);
                    }}>
                    {({ values, errors, handleChange, handleSubmit }) => (
                        <div className="row">
                            <div className="col-12 mb-5">
                                <FormControl fullWidth className="t-form-group-custom">
                                    <FormLabel>แจ้งข้อความแนบท้าย</FormLabel>
                                    <TextField
                                        value={values?.text}
                                        name="text"
                                        onChange={handleChange}
                                        variant="outlined"
                                        error={Boolean(errors?.text)}
                                        helperText={errors?.text}
                                    />
                                </FormControl>
                            </div>
                            <div className="col-12">
                                <div className="d-flex justify-content-center align-items-center w-100">
                                    <Button
                                        onClick={() => response({ status: false }, type)}
                                        className="btn t-btn-gray mx-3">
                                        ไม่
                                    </Button>
                                    <Button onClick={handleSubmit} className="btn t-btn-primary mx-3">
                                        ใช่
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Formik>
            </div>
        );
    } else return <></>;
}
